<template>
    <div style="padding-left: 20px; padding-right: 20px;" id="target-section">
        <div class="title">{{ title }}</div>
        <div>
            <div class="events-grid">
                <!-- Visible Events -->
                <div class="card" v-for="(item, index) in visibleEvents" :key="index" @click="goToDetails(item.id)">
                    <!-- <img :src="item.imageUrl" :alt="item.title" class="card-image" v-if="item.imageUrl" />
                    <div v-else class="card-placeholder">Image not available</div> -->
                    <div class="card-container">
                        <img :src="item.imageUrl" :alt="item.title" class="card-image" v-if="item.imageUrl" />
                        <div v-else class="card-placeholder">Image not available</div>
                        <div class="city-text">{{ item.city }}</div>
                    </div>

                    <!-- <div style="position: absolute; top: 1%; right: 2%;">
                        <HeartIcon :isTapped="item.isLiked ?? false" @toggle="handleToggleHeart(item, $event)" @click.stop />
                    </div> -->
                    <div class="card-content">
                        <h3 class="card-title">{{ item.title }}</h3>
                        <p class="card-subtitle">
                            <i class="fas fa-map-marker-alt icon"></i>
                            {{ item.street }}
                        </p>
                        <p class="card-subtitle">
                            <i class="fas fa-clock icon"></i>
                            <span class="date-text">{{ formatDate(item.startDate) }} {{ formatTime(item.startTime)
                            }}</span>
                        </p>
                        <!-- <p class="card-subtitle">{{ item.street }}</p>
                        <p class="card-subtitle">{{ formatDate(item.startDate) }}, {{ formatTime(item.startTime) }}</p> -->
                    </div>
                </div>
            </div>

            <!-- Shimmer Row (Placeholder) -->
            <div v-if="isLoading" class="events-grid">
                <div class="shimmer-card card" v-for="n in 5" :key="n"></div>
            </div>

            <!-- Error Message -->
            <div v-if="hasError" class="error-message">Failed to load events. Please try again later.</div>

            <!-- Scroll Sentinel -->
            <div class="scroll-sentinel"></div>
        </div>

        <div style="width: 100%; display: flex; justify-content: space-between; padding: 10px;">
            <b-button v-if="isMobile && showScrollToTop" @click="scrollToTop" class="scroll-to-top">
                ↑ Skrolla till början ↑
            </b-button>
            <b-button @click="fetchEvents" class="load-more-events">
                Visa fler...
            </b-button>
        </div>
    </div>
</template>

<script>
import { toRaw } from "vue";
import AxiosInstance from "../api/axios";
import EventResponse from "../aggrigates/events/models/EventResponse.js";
// import HeartIcon from "../components/HeartIcon.vue";
import UserEventBusMixin, { UserEventBus } from "../api/UserEventBusMixin.js";
import { EventBus } from '../api/EventBusMixin';

export default {
    mixins: [UserEventBusMixin],
    // components: { HeartIcon },
    props: {
        title: {
            type: String,
            required: true,
        },
        apiUrl: {
            type: String,
            required: true,
        },
        isMobile: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            events: [],
            visibleEvents: [],
            isLoading: false,
            hasError: false,
            pageNumber: 0,
            allEventsIsLoaded: false,
            showScrollToTop: false,
            scrollObserver: null,
        };
    },
    mounted() {
        if (sessionStorage.getItem('isNavigatingBack') === 'true') {
            this.restoreState();
        } else {
            this.fetchEvents();
        }
    },
    methods: {
        restoreState() {
            const storedEvents = sessionStorage.getItem('events');
            const storedVisibleEvents = sessionStorage.getItem('visibleEvents');
            const storedPageNumber = sessionStorage.getItem('pageNumber');

            if (storedEvents && storedVisibleEvents && storedPageNumber !== null) {
                this.events = JSON.parse(storedEvents);
                this.visibleEvents = JSON.parse(storedVisibleEvents);
                this.pageNumber = parseInt(storedPageNumber, 10);

                // Ensure the state is not being overwritten
                this.allEventsIsLoaded = this.events.length === 0;
                this.showScrollToTop = this.pageNumber > 0;
            }
        },
        goToDetails(id) {
            window.location.href = `/eventdetails/${id}`;
        },
        handleToggleHeart(item, newValue) {
            /* eslint-disable */
            if (!this.$isLoggedIn()) {
                EventBus.emit('accountModal', { open: 'login-account' });
            }
            else {
                if (item.liked) {
                    UserEventBus.emit("un-event-like", item.id);
                }
                else {
                    UserEventBus.emit("event-like", item.id);
                }
                item.liked = newValue;
            }
        },
        async fetchEvents() {
            if (this.isLoading || this.allEventsIsLoaded) return;
            this.isLoading = true;
            this.hasError = false;

            try {
                this.showScrollToTop = this.pageNumber > 0;
                const eventResponse = new EventResponse();
                const response = await AxiosInstance.get(this.apiUrl + this.pageNumber);
                eventResponse.fromResponse(response.data);

                if (eventResponse.items.length === 0) {
                    this.allEventsIsLoaded = true;
                    return;
                }

                this.pageNumber++;
                this.events = toRaw(eventResponse.items);
                this.loadMoreEvents();

            } catch (error) {
                console.error("Error fetching events:", error);
                this.hasError = true;
            } finally {
                this.isLoading = false;
            }
        },
        setupScrollObserver() {
            const options = {
                root: this.$refs.scrollContainer,
                rootMargin: "0px",
                threshold: 1.0,
            };

            this.scrollObserver = new IntersectionObserver(this.handleBottomReached, options);

            const sentinel = this.$refs.scrollContainer.querySelector(".scroll-sentinel");
            if (sentinel) {
                this.scrollObserver.observe(sentinel);
            }
        },

        handleBottomReached(entries) {
            if (this.isLoading || this.allEventsIsLoaded) return;

            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.fetchEvents();
                }
            });
        },

        handleScroll() {
            const container = this.$refs.scrollContainer;
            if (!container) return;

            const scrollTop = container.scrollTop;
            const scrollHeight = container.scrollHeight;
            const clientHeight = container.clientHeight;

            const scrollPercentage = (scrollTop + clientHeight) / scrollHeight;

            if (scrollPercentage >= 0.7 && !this.isLoading) {
                this.fetchEvents();
            }

            // Toggle the visibility of the Scroll to Top button
            this.showScrollToTop = scrollTop > 200;
            console.log(this.showScrollToTop);
        },
        scrollToTop() {
            const targetElement = document.getElementById("target-section");
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        },
        loadMoreEvents() {
            const newEvents = toRaw(this.events);
            if (newEvents.length > 0) {
                this.visibleEvents.push(...newEvents);
            }

            sessionStorage.setItem('events', JSON.stringify(this.events));
            sessionStorage.setItem('visibleEvents', JSON.stringify(this.visibleEvents));
            sessionStorage.setItem('pageNumber', JSON.stringify(this.pageNumber));
            sessionStorage.setItem('isNavigatingBack', 'false');
        },
        formatDate(dateString) {
            const now = new Date();
            const inputDate = new Date(dateString);

            if (
                inputDate.getFullYear() === now.getFullYear() &&
                inputDate.getMonth() === now.getMonth() &&
                inputDate.getDate() === now.getDate()
            ) {
                return "Idag";
            }

            const differenceInTime = inputDate.getTime() - now.getTime();
            const differenceInDays = Math.ceil(differenceInTime / (1000 * 60 * 60 * 24));

            if (differenceInDays > 0 && differenceInDays <= 7) {
                return `Om ${differenceInDays} dagar`;
            }

            return dateString.split("T")[0];
        },
        formatTime(timeString) {
            return timeString.split(":").slice(0, 2).join(":");
        },
    },
    beforeUnmount() {
        if (this.scrollObserver) {
            this.scrollObserver.disconnect();
        }
    },
};
</script>

<style scoped>
.scroll-sentinel {
    width: 100%;
    height: 1px;
    background: transparent;
}

.title {
    color: white;
    font-size: 15px;
    padding-bottom: 5px;
}

.infinite-scroll-container {
    display: flex;
    flex-direction: column;
    max-height: 80vh;
    overflow-y: scroll;
    scrollbar-width: none;
    -ms-overflow-style: none;
    padding: 20px;
    padding-top: 0px;
    background-color: #141313;
}

.infinite-scroll-container::-webkit-scrollbar {
    display: none;
}

.events-grid {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    /* Always 5 columns */
    gap: 15px;
}

/* Shimmer Row */
.shimmer-card {
    margin-top: 20px;
    background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
    height: 250px;
}

.card {
    border: none;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    flex-direction: column;
    height: 230px;
    cursor: pointer;
}

.card-image {
    width: 100%;
    height: 145px;
    /* Ensure image takes 60% of the card height */
    object-fit: cover;
    /* Prevent distortion and crop to fill the space */
    display: block;
}

.city-text {
    position: absolute;
    bottom: 1px;
    right: 1px;
    color: white;
    font-size: 12px;
    background: rgba(0, 0, 0, 0.5);
    padding: 5px 10px;
    border-radius: 5px;
}

.card-container {
    /* margin-top: 7%; */
    position: relative;
    display: inline-block;
}

.card-placeholder {
    width: 100%;
    height: 65%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f0f0f0;
    color: #999;
}

.card-content {
    padding: 10px;
    /* padding-top: 5px; */
    flex-grow: 1;
    /* Makes sure the content takes the remaining space */
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.icon {
    margin-right: 5px !important;
}

.fa-clock {
    position: relative;
    right: 1px !important;
}

/* .card-title {
    font-size: 12px !important;
    margin: 0 0 5px;
    color: white;
    margin-bottom: 10px;
    margin-top: 5px;
} */

.card-title {
    font-size: 12px !important;
    margin: 0 0 5px;
    color: white;
    margin-bottom: 10px;

    /* Ensures text stays on one line */
    white-space: nowrap;

    /* Hide overflow text */
    overflow: hidden;

    /* Add "..." when text overflows */
    text-overflow: ellipsis;
    display: block;
    /* Ensures the text behaves as a block element */
    width: 100%;
    /* Adjust based on your design */
}


.card-subtitle {
    font-size: 10px;
    font-weight: 600;
    color: white;
    margin-bottom: 5px;
}

@media (max-width: 1200px) {
    .events-grid {
        grid-template-columns: repeat(4, 1fr);
        /* 3 columns */
    }

    .card {
        height: 250px;
        /* Reduced height */
    }

    .card-title {
        font-size: 14px;
    }

    .card-subtitle {
        font-size: 11px;
    }
}

@media (max-width: 850px) {
    .events-grid {
        grid-template-columns: repeat(3, 1fr);
        /* 3 columns */
    }

    .card {
        height: 200px;
        /* Reduced height */
    }

    .card-title {
        font-size: 10px;
    }

    .card-subtitle {
        font-size: 9px;
    }
}

@media (max-width: 568px) {
    .events-grid {
        grid-template-columns: repeat(2, 1fr);
    }

    .card {
        height: 230px;
    }

    .card-title {
        font-size: 10px !important;
    }

    .card-subtitle {
        font-size: 9px !important;
    }
}

@media (max-width: 480px) {
    .events-grid {
        grid-template-columns: repeat(2, 1fr);
    }

    .card {
        height: 230px;
    }
}

@keyframes shimmer {
    0% {
        background-position: -200% 0;
    }

    100% {
        background-position: 200% 0;
    }
}

@media (max-width: 380px) {
    .events-grid {
        grid-template-columns: repeat(1, 1fr);
    }

    .card {
        height: 200px;
    }

    .card-title {
        font-size: 10px;
    }

    .card-subtitle {
        font-size: 8px;
    }
}

.error-message {
    text-align: center;
    padding: 10px;
    color: red;
    font-weight: bold;
}

.scroll-to-top {
    margin: 0;
    text-align: left;
    width: fit-content;
    font-size: 14px;
    cursor: pointer;
    z-index: 1000;
    display: block;
    height: 37px;
    margin-top: 50px;
    color: white;
    background-color: rgba(0, 0, 0, 0.3);
    border-color: rgba(0, 0, 0, 0.3);
}

.load-more-events {
    display: block;
    margin: 50px auto;
    /* Centers horizontally */
    text-align: center;
    width: fit-content;
    font-size: 14px;
    cursor: pointer;
    z-index: 1000;
    color: white;
    background-color: rgba(0, 0, 0, 0.3);
    border-color: rgba(0, 0, 0, 0.3);
}
</style>
